import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import {
  faArrowDownToBracket,
  faFileContract,
} from "@fortawesome/pro-light-svg-icons"
import { PedidoReadingFiltersDtoProps } from "api/DTOs/PedidoReadingFiltersDto"
import { formatCurrency } from "common/utils/currency"
import { TYPES_DOCUMENTOS } from "features/Crear/pages/FormCreacionDocumento/constant"
import { EstadoRevisionActual } from "features/Documentos/components/EstadoRevisionActual/EstadoRevisionActual"
import { TFunction } from "i18next"
import { frontendDateFormat } from "utils/formatDate"

interface PedidosRecibidosColumnsProps {
  t: TFunction
  handleDownloadPdfPedido: (id: string, serie: string, t: TFunction) => void
  handleConvertirDocumento: (
    rowData: PedidoReadingFiltersDtoProps,
    finalType: string
  ) => void
}
export const PEDIDOS_RECIBIDOS_COLUMNS = ({
  t,
  handleDownloadPdfPedido,
  handleConvertirDocumento,
}: PedidosRecibidosColumnsProps) => {
  const columns = [
    {
      header: t("crear.pedido.tab.headerEmisionDate"),
      field: "fechaEmision",
      key: "fechaEmision",
      body: ({ fechaEmision }: PedidoReadingFiltersDtoProps) =>
        fechaEmision ? frontendDateFormat(new Date(fechaEmision)) : "",
      style: { width: "10%" },
      sortable: true,
      sortField: "fechaEmision",
    },
    {
      header: t("crear.pedido.tab.headerNumOrder"),
      field: "serie",
      key: "serie",
      style: { width: "15%" },
      sortable: true,
      sortField: "serie",
    },
    {
      header: t("crear.pedido.tab.headerProveedor"),
      key: "cliente",
      field: "Librado.RazonSocial",
      body: (rowData: PedidoReadingFiltersDtoProps) => {
        return `${rowData.razonSocialLibrado} (${rowData.nifLibrado})`
      },
      sortable: true,
      sortField: "Librado.RazonSocial",
    },
    {
      header: t("crear.pedido.tab.headerState"),
      field: "estadoRevisionActual",
      key: "estadoRevisionActual",
      body: ({ estadoRevisionActual }: PedidoReadingFiltersDtoProps) => {
        return estadoRevisionActual
          ? EstadoRevisionActual(estadoRevisionActual)
          : ""
      },
      style: { width: "11%" },
      sortable: true,
      alignCol: "center",
      sortField: "estadoRevisionActual",
    },
    {
      header: t("crear.pedido.tab.headerImport"),
      field: "importe",
      key: "importe",
      className: "!tw-text-end",
      style: { width: "11%" },
      body: ({ importe }: PedidoReadingFiltersDtoProps) =>
        formatCurrency(importe),
      sortable: true,
      alignCol: "right",
      sortField: "importe",
    },
    {
      key: "opciones",
      style: { width: "4%" },
      className: "!tw-p-2",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end",
      alignCol: "right",
      body: (rowData: PedidoReadingFiltersDtoProps) => {
        if (!rowData.id) return null
        return (
          <OptionsMenuStorybook
            position='right'
            id={rowData.id}
            items={[
              {
                title: `${t("crear.factura.tab.downloadLabel")}`,
                hasRedirect: true,
                action: () => {
                  rowData.id &&
                    handleDownloadPdfPedido(rowData.id, `${rowData.serie}`, t)
                },
                icon: faArrowDownToBracket,
              },
              {
                title: `${t("crear.presupuesto.tab.convertirLabel")}`,
                hasRedirect: false,
                subMenu: [
                  {
                    title: `${t("asociateDoc.deliveryLabel")}`,
                    action: () =>
                      handleConvertirDocumento(
                        rowData,
                        TYPES_DOCUMENTOS.ALBARAN
                      ),
                    icon: faFileContract,
                  },
                ],
              },
            ]}
          />
        )
      },
    },
  ]
  return columns
}
